import React from 'react';

const AgeVerification = ({ onVerified }) => {
  const handleVerify = () => {
    localStorage.setItem('ageVerified', 'true');
    onVerified();
  };

  const handleDecline = () => {
    // Redirect to a page explaining age restrictions
    window.location.href = 'https://www.google.com'; // You can change this to your own page
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center">
        {/* Warning Icon */}
        <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
          <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>

        {/* Title */}
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Age Verification Required
        </h2>

        {/* Message */}
        <p className="text-gray-600 mb-6 leading-relaxed">
          You must be 18 years or older to access this website. 
          By clicking "I am 18 or older", you confirm that you meet the age requirement.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={handleVerify}
            className="flex-1 bg-gradient-to-r from-cigar-gold to-cigar-bronze hover:from-cigar-bronze hover:to-cigar-gold text-cigar-dark px-6 py-3 rounded-lg font-semibold transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
          >
            I am 18 or older
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 px-6 py-3 rounded-lg font-semibold transition-all duration-200"
          >
            I am under 18
          </button>
        </div>

        {/* Legal Notice */}
        <p className="text-xs text-gray-500 mt-4">
          By entering this site, you agree to our Terms of Service and Privacy Policy.
        </p>
      </div>
    </div>
  );
};

export default AgeVerification;
